module.exports = __webpack_public_path__ + "media/gulp.5db53c45.mp3";